var render, staticRenderFns
import script from "./StatCardsChart.vue?vue&type=script&lang=js&"
export * from "./StatCardsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b5a57",
  null
  
)

export default component.exports